import React, { FC, useEffect, useState } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PublicSelfServeLayout from '../layouts/PublicSelfServeLayout';
import { getClientSecretKeyFromStore } from '../lib/helper';

import { RouteComponentProps } from 'react-router-dom';
import { logOutApi } from '../api/login';
import { clearAuthSessionAction } from '../redux/actions/login';
import {
  removeIsLiveMerchant,
  removeUserAuthenticated,
} from '../lib/localStorage';

const CompleteProfileRoute: FC<{
  component: FC<RouteComponentProps>;
  path: string;
  exact?: boolean;
  loginState;
  roleState;
  isAdmin: boolean;
  clearAuthSessionAction: CallableFunction;
}> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { path, exact, ...rest } = props;
  const Component = props.component;

  const { isUserAuthenticated, isWaitingForAPIResponse } = props.loginState;
  const [isInvalidatingSession, setIsInvalidatingSession] = useState(false);
  const [hasInvalidatedSession, setHasInvalidatedSession] = useState(false);
  const clientSecretKey = getClientSecretKeyFromStore();
  const hasDashboardSessionMarker = localStorage.getItem('user') === 'true';
  const shouldInvalidateDashboardSession =
    isUserAuthenticated || hasDashboardSessionMarker;

  useEffect(() => {
    if (shouldInvalidateDashboardSession || !isWaitingForAPIResponse) return;

    props.clearAuthSessionAction();
  }, [shouldInvalidateDashboardSession, isWaitingForAPIResponse]);

  useEffect(() => {
    if (
      !shouldInvalidateDashboardSession ||
      hasInvalidatedSession ||
      isInvalidatingSession
    ) {
      return;
    }

    const invalidateDashboardSession = async () => {
      setIsInvalidatingSession(true);
      try {
        await logOutApi();
      } catch (error) {
        // Public self-serve links should not be blocked by logout failures.
      } finally {
        removeUserAuthenticated();
        removeIsLiveMerchant();
        props.clearAuthSessionAction();
        setHasInvalidatedSession(true);
        setIsInvalidatingSession(false);
      }
    };

    invalidateDashboardSession();
  }, [
    hasInvalidatedSession,
    isInvalidatingSession,
    shouldInvalidateDashboardSession,
  ]);
  useEffect(() => {
    if (clientSecretKey) {
      const loadScriptByURL = (id, url, callback) => {
        const isScriptExist = document.getElementById(id);
        if (!isScriptExist) {
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = url;
          script.id = id;
          script.onload = function () {
            if (callback) callback();
          };
          document.body.appendChild(script);
        }

        if (isScriptExist && callback) callback();
      };
      // load the script by passing the URL
      loadScriptByURL(
        'recaptcha-key',
        `https://www.google.com/recaptcha/enterprise.js?render=${clientSecretKey}`,
        function () {}
      );
    }
  }, [clientSecretKey]);

  useEffect(() => {
    const ele = document.getElementsByClassName('grecaptcha-badge')[0];
    if (ele?.hasAttribute('hidden')) {
      ele.removeAttribute('hidden');
    }
  }, []);

  const canRenderPublicRoute =
    !shouldInvalidateDashboardSession || hasInvalidatedSession;

  return canRenderPublicRoute ? (
    <Route
      path={path}
      exact={exact}
      render={(renderProps) => (
        <PublicSelfServeLayout>
          <Component {...renderProps} />
        </PublicSelfServeLayout>
      )}
    />
  ) : (
    <></>
  );
};

const mapStateToProps = ({ loginReducer }) => ({
  loginState: loginReducer.loginState,
  roleState: loginReducer.roleState,
  isAdmin: loginReducer.loginState.isAdmin,
});

export default connect(mapStateToProps, {
  clearAuthSessionAction,
})(CompleteProfileRoute);
